export const replaceDashWithSpaces = (text = '') => text.replace(/-/g, ' ')
